import { InjectionToken, Signal } from '@angular/core';

export const BOTTOM_PANE_ID = new InjectionToken<string>('BOTTOM_PANE_ID');
export const BOTTOM_PANE_DATA = new InjectionToken<unknown>('BOTTOM_PANE_DATA');

export interface BottomPaneState {
  isOpen: Signal<boolean>;
  height: Signal<number>;
  minimized: Signal<boolean>;
  dragging: Signal<boolean>;
}

export const BOTTOM_PANE_STATE = new InjectionToken<BottomPaneState>('BOTTOM_PANE_STATE');